module.exports = __webpack_public_path__ + "static/media/bg.2b708f32.png";